// src/utils/financePermissions.js
// Updated: Tuesday, August 4, 2026 at 8:25 PM EDT

export const FINANCE_ROLES = Object.freeze({
  VIEWER: 'viewer',
  COUNTER: 'counter',
  ADMIN: 'admin',
});

export const isSuperAdministrator = (profile) =>
  profile?.role === 'Super Administrator';

export const hasFinanceAccess = (profile) =>
  Boolean(
    profile?.status === 'active' &&
    profile?.churchId &&
    (isSuperAdministrator(profile) ||
      Object.values(FINANCE_ROLES).includes(profile?.financeRole)),
  );

export const canViewFinancials = hasFinanceAccess;

export const canEnterFinancialData = (profile) =>
  hasFinanceAccess(profile) &&
  (isSuperAdministrator(profile) ||
    [FINANCE_ROLES.COUNTER, FINANCE_ROLES.ADMIN].includes(profile?.financeRole));

export const canApproveFinancialData = (profile) =>
  hasFinanceAccess(profile) &&
  (isSuperAdministrator(profile) || profile?.financeRole === FINANCE_ROLES.ADMIN);

export const canConfigureFinancials = canApproveFinancialData;
export const canViewFinancialAudit = canApproveFinancialData;

export const getFinanceRoleLabel = (profile) => {
  if (isSuperAdministrator(profile)) return 'Super Administrator';
  if (profile?.financeRole === FINANCE_ROLES.ADMIN) return 'Finance Administrator';
  if (profile?.financeRole === FINANCE_ROLES.COUNTER) return 'Counter';
  if (profile?.financeRole === FINANCE_ROLES.VIEWER) return 'Viewer';
  return 'No Financial Access';
};
